<template>
    <el-container  style="display: block;background-color: #fff;margin-left: 6%;overflow: hidden;">
      <el-row style="color: #fff;">
        <!-- <el-row :span="2" style="margin-top: 30px;color: #000;">
            名称:<el-input v-model="addname" style="width: 350px;" placeholder="请输入名称"></el-input>
        </el-row>        
        
       <el-button type="primary" style="background-color: #409eff;margin-top: 20px;" @click="add()">添加</el-button> -->
      </el-row>
      <el-row  style="margin-top: 30px;">
        <template>
          <el-table
        	:data="list"
            height="1000"
        	border
        	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
          <el-table-column
      
            width="300"
            label="名称"
             >
             <template slot-scope="scope">
                 <!-- <div>{{scope.row.name}}</div> -->
								 <div  @click="dischange(scope.row.name,scope.row.id,1)">{{scope.row.name}}</div>
             </template>
          </el-table-column>
		  <el-table-column
		        
		    width="300"
		    label="type"
		     >
		     <template slot-scope="scope">
		  		<!-- <div>{{scope.row.type}}</div> -->
		       <div  @click="dischange(scope.row.type,scope.row.id,2)">{{scope.row.type}}</div>  
		     </template>
		  </el-table-column>
          <el-table-column
                
            width="300"
            label="位置图"
             >
             <template slot-scope="scope">
				 <img @click="bigImg(scope.row.t_img)" :src="scope.row.t_img" style="width: 150px;height: auto;" />
                 
             </template>
          </el-table-column>
      
          <el-table-column
      
            width="200"
            label="操作"
             >
             <template slot-scope="scope">
               <el-row>
                 
				 <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="guanli(scope.row.id)">管理</el-col>
      
               </el-row>
             </template>
          </el-table-column>
          </el-table>
        </template>
        
      </el-row>
      <el-dialog
        title="修改"
        :visible.sync="disDialogVisible"
        width="30%"
        center>
        <span>修改内容：</span>
        <input type="text" style="width: 50%;height: 30px;padding-left: 5px;"  v-model="names"/>
        
        <span slot="footer" class="dialog-footer">
        <el-button @click="disDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dodisChange()">确 定</el-button>
        </span>
    </el-dialog>
	<el-dialog
	    title="大图预览"
	    :visible.sync="disDialogVisibleImg"
	    width="30%"
	    center>
	    <img :src="big_img" style="width: 100%;" />
	</el-dialog>
	<el-dialog
	    title="添加回应"
	    :visible.sync="disDialogVisiblehy"
	    width="20%"
	    center>
	    
	    <!-- <input type="text" style="width: 50%;height: 30px;padding-left: 5px;"  v-model="names"/> -->
	    <el-input
	      type="textarea"
	      :rows="30"
	      placeholder="请输入内容"
	      v-model="textarea">
	    </el-input>
	    <span slot="footer" class="dialog-footer">
	    <el-button @click="disDialogVisiblehy = false">取 消</el-button>
	    <el-button type="primary" @click="doAddHy()">确 定</el-button>
	    </span>
	</el-dialog>
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <span>确认删除？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="doDell()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="管理"
        :visible.sync="dialogVisiblegl"
        width="30%"
        >
		<el-button type="primary" style="background-color: #409eff;margin-top: 5px;margin-bottom: 5px;" @click="addhy()">添加回应</el-button>
		
        <el-table
            :data="lists"
            height="600"
            border
            style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
        <el-table-column              
          width="300"
          label="名称"
           >
           <template slot-scope="scope">
               <div>{{scope.row.name}}</div>
           </template>
        </el-table-column>   
        <!-- <el-table-column
          width="300"
          label="类型"
           >
           <template slot-scope="scope">
               <div v-if="scope.row.type==1">打开回应</div>
			   <div v-if="scope.row.type==2">关闭回应</div>
           </template>
        </el-table-column>  -->     
        <el-table-column              
          width="200"
          label="操作"
           >
           <template slot-scope="scope">
             <el-row>
               <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="delh(scope.row.id)">删除</el-col>
        		
              
             </el-row>
           </template>
        </el-table-column>
        </el-table>
      </el-dialog>
    </el-container>
  </template>
  
  <script>
    import { ref } from 'vue'
    
    export default {
      data() {
         return {
		  page:1,
		  count:0,	 
		  values:'左上角',
		  options:['左上角','左下角','右上角','右下角'],	 
		  list:[],
          appid:window.localStorage.getItem('appid'), 
          basename:window.localStorage.getItem('base'),  
          addname:'',
          name:'',
          mediaUrl:'',
		  disDialogVisible:false,
		  dialogVisible:false,
          fileList:[],
          fileList1:[],
          fields:[],       
          formData: {},                   
          screenWidth : window.innerWidth,
          screenHeight : window.innerHeight,    
          names:'',
		  lists:[],
		  dialogVisiblegl:false,
		  disDialogVisiblehy:false,
          g_id:0,
		  textarea:'',
		  big_img:'',
		  disDialogVisibleImg:false
            
  
        }
      },
      directives: {
      },
      created() {
         
        this.loadList();
      //   alert(window.localStorage.getItem('base'))
      },
  
      methods:{
		bigImg(img){
			this.big_img = img
			this.disDialogVisibleImg = true
		},
		doAddHy(){
			const axiosInstance = this.$axios.create({
			  headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
			  withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			if(this.textarea == ''){
			  this.msg('请填写内容','error')
			  return false
			}            
			
			axiosInstance({
			  method:'post',
			  url:'http://y31p.yoooooo.com/index.php/index/data/yzzmbthAdd',
			  data:{
			      name:this.textarea.replace(/\n/g, ';'),
			      id:this.g_id             
			      
			  }
			})
			.then(res=>{			
			  this.textarea = ''
			  this.disDialogVisiblehy = false
			  this.$message({
			      type: 'success',
			      message: '添加成功'
			     });
			  this.loadListh()
			})
			.catch(err=>{
			  
			});
		},
        addhy(){
			this.disDialogVisiblehy = true
		},
        guanli(id){
			this.dialogVisiblegl = true
			this.g_id = id
			this.loadListh()			
		},
        
        dischange(name,id,t){
          this.t = t;
          this.changeId = id
          this.names = name
          this.disDialogVisible = true
        },
        dodisChange(){
          const axiosInstance = this.$axios.create({
          	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
          	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
          });
          axiosInstance({
          	method:'post',
          	params:{
              id:this.changeId,
              name:this.names,
              t:this.t
          	},
          	url:'http://y31p.yoooooo.com/index.php/index/data/yzzmbtChanges'
          })
          .then(res=>{
            console.log(res.data.code)
            if(res.data.code == 200){
              this.disDialogVisible = false
              this.loadList()
            }else{
              this.msg('名称重复','error');
              this.disDialogVisible = false
        
            }
        
        
        
          })
          .catch(err=>{
        
          });
        },
          loadList(){
            const axiosInstance = this.$axios.create({
              headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
              withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
            });
            axiosInstance({
              method:'post',
              data:{
                p:this.page,
                
                
              },
              url:'http://y31p.yoooooo.com/index.php/index/data/yzzmbtList'
            })
            .then(res=>{
              this.list = res.data.data
			  
            })
            .catch(err=>{
  
            });
          }, 
		  loadListh(){
		    const axiosInstance = this.$axios.create({
		      headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
		      withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
		    });
		    axiosInstance({
		      method:'post',
		      data:{
		        id:this.g_id,
		        
		        
		      },
		      url:'http://y31p.yoooooo.com/index.php/index/data/yzzmbthList'
		    })
		    .then(res=>{
		      this.lists = res.data.data
		  			  
		    })
		    .catch(err=>{
		    
		    });
		  }, 
          del(id){
            const axiosInstance = this.$axios.create({
            	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
            	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
            });
          
            
            axiosInstance({
            	method:'post',
            	params:{
            		id:id,
            	},
            	url:'http://y31p.yoooooo.com/index.php/index/data/yzzmbtDel'
            })
            .then(res=>{
            	if(res.data.code == 200){
          
                 this.$message({
                 	type: 'success',
                 	message: '操作成功'
                 });
                 this.loadList();
            	}else{
          
            	}
          
            })
            .catch(err=>{
          
            });
          },
		  delh(id){
		    const axiosInstance = this.$axios.create({
		    	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
		    	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
		    });
		  
		    
		    axiosInstance({
		    	method:'post',
		    	params:{
		    		id:id,
		    	},
		    	url:'http://y31p.yoooooo.com/index.php/index/data/yzzmbthDel'
		    })
		    .then(res=>{
		    	if(res.data.code == 200){
		  
		         this.$message({
		         	type: 'success',
		         	message: '操作成功'
		         });
		         this.loadListh();
		    	}else{
		  
		    	}
		  
		    })
		    .catch(err=>{
		  
		    });
		  },
          add(){
            const axiosInstance = this.$axios.create({
              headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
              withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
            });
            if(this.addname == ''){
              this.msg('请填写名称','error')
              return false
            }            
                   
            axiosInstance({
              method:'post',
              url:'http://y31p.yoooooo.com/index.php/index/data/yzzmbtAdd',
              data:{
                  name:this.addname,
                                
                  
              }
            })
            .then(res=>{			
              this.addname = ''
              
              this.$message({
                  type: 'success',
                  message: '添加成功'
                 });
              this.loadList()
            })
            .catch(err=>{
  
            });
          },
          msg(msg,type){
              this.$message({
                message: msg,
                type: type
              });
          },
  
      }
  
  
    }
  </script>
  
  <style>
  
  body{
      background-color: #fff;
      font-family: hanyi;
  }
  .el-scrollbar__bar{
      overflow: hidden;
  }
  
  
 
  
  
  </style>
  


// WEBPACK FOOTER //
// src/components/main/yzzmbt.vue